import axios from 'axios';

const syncInterceptors = {
  setSyncInterceptors: (axiosInstance) => {
    const requestList = {};
    const canceledMessage = 'canceled';

    axiosInstance.interceptors.request.use(
      (config) => {
        const requestId = config.requestId ?? config.url;

        // Debounce requests from the same url
        if (requestList[requestId]?.timeout) {
          clearTimeout(requestList[requestId].timeout);
        }

        // Cancel the previous request if it exists
        if (requestList[requestId]?.cancelFn) {
          requestList[requestId].cancelFn(canceledMessage);
        }

        // Add the token to the request
        config.cancelToken = new axios.CancelToken(function executor(c) {
          // Save the token cancel function to cancel the request in the future.
          requestList[requestId] = { cancelFn: c };
        });

        return new Promise((resolve) => {
          requestList[requestId].timeout = setTimeout(() => {
            requestList[requestId].timeout = null;
            resolve(config);
          }, 500);
        });
      },

      (error) => {
        return Promise.reject(error);
      }
    );

    axiosInstance.interceptors.response.use(
      (response) => {
        // Remove source from the request list
        const requestId = response?.config?.requestId ?? response?.config?.url;
        requestList[requestId] = null;

        return response;
      },

      (error) => {
        // Indicates if the request is cancelled
        return Promise.reject({ ...error, canceled: error?.message === canceledMessage });
      }
    );
  },
};

export default syncInterceptors;
